module.exports = __webpack_public_path__ + "img/ablakozas.33fc373f.jpg";